<template>
    <div class="main-form">
        <h1 class="header-title">Required Skills pending/expired</h1>
        <div>
            <p>
                This report shows all the required skills ordered by person which have expired or without expiration date.                
            </p>
        </div>
        <div class="buttons">
            <!--<button type="button" class="btn btn-secondary btn-sm" @click="download(false)">Open</button>-->
            <button type="button" class="btn btn-primary btn-sm" @click="download(true)">Download</button>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
            }
        },
        async created() {
        },
        computed: {
        },
        methods: {
            download(download) {
                this.$store.dispatch('reports/getRequiredSkillsByPersonReport', { download });
            },
        }
    }
</script>

<style>
</style>
